import React from 'react'
import People from 'src/app/People/People'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import PeopleInvitedToOrg from 'src/navigation/appRoutes/people/peopleInvitedToOrg.appRoute'
import PeopleMembers from 'src/navigation/appRoutes/people/peopleMembers.appRoute'
import { peopleRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const PeopleAppRoute: AppRoute = {
  id: AppLocation.People,
  routeProps: peopleRouteProps,
  component: <People />,
  subRoutes: [PeopleMembers, PeopleInvitedToOrg],
  meta: { contentType: SidenavContentType.Main },
}

export default PeopleAppRoute
